import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const customIssueRoute: InvariantJiraRoute = {
	name: 'servicedesk-queues-custom-issue-detail',
	path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/:issueKey',
	query: ['oldIssueView?'],
	exact: true,
};
